import { PsHttpService } from '@patsnap/tahiti-core';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { PatSnapSuccessResponseData } from '@patsnap/tahiti-core';
import type {
    ManualSearchSaveApi,
    ManualSearchSaveRequest,
    ManualSearchSaveResponse,
} from '../manual-search-save-api';
import { coreTelecomApiUrlPrefix } from '@telecom/shared/domain-config';

/**
 * 手动检索保存API实现
 * @description 实现保存手动检索结果的API操作
 */
@injectable()
export class ManualSearchSaveApiImpl
    extends PsHttpService
    implements ManualSearchSaveApi {

    get options() {
        return {
            baseURL: coreTelecomApiUrlPrefix,
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }

    /**
     * 保存手动检索结果
     * @param data 手动检索保存请求参数
     * @returns 保存结果的响应
     * @description 调用后端API保存手动检索的专利结果
     */
    async saveManualSearchResult(data: ManualSearchSaveRequest): Promise<ManualSearchSaveResponse> {
        const result = await this.post<PatSnapSuccessResponseData<ManualSearchSaveResponse>>({
            url: 'novelty-search/manual-search-save',
            data,
        });
        return result.data;
    }
}
